import React, { PureComponent } from "react";
import { connect } from "react-redux";
// import { getSentimentColor, downloadCSVData, downloadCanvasWithTitle } from "../utils";
import {
    updatePostAfterSentimentUpdateWidget,
    updatePostAfterMarkAsIrrWidget,
    updatePostAfterTagToClientWidget,
    downloadComments,
} from "../../../../../actions/dashboardAction";
import DimmerComponent from "../../DimmerComponent";
import { numberWithCommas } from "../utils";
import NoData from "../NoData/NoData";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";

import "./RawConversations.scss";
import RawConversationPosts from "./RawConversationPosts";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
class RawConversations extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
        };
        this.masonryOptions = {
            transitionDuration: 0,
            fitWidth: true,
        };
    }

    componentDidUpdate(prevProps) {
        // if (this.props.resizedCount !== prevProps.resizedCount) {
        // }
    }

    updatePostAfterSentimentUpdate = (value) => {
        const conversationsData = [...this.props.data.hits];
        conversationsData[value.postIndex] = value.data;
        this.props.updatePostAfterSentimentUpdateWidget({ conversationsData: { ...this.props.data, hits: conversationsData }, widgetId: this.props.widget.id });
    };

    updatePostAfterMarkAsIrr = (value) => {
        const conversationsData = this.props.data.hits.filter((post) => post._id !== value.postId);
        this.props.updatePostAfterMarkAsIrrWidget({ conversationsData: { ...this.props.data, hits: conversationsData }, widgetId: this.props.widget.id });
        this.props.fetchDataFromWidget();
    };

    updatePostAfterTagToClient = (value) => {
        const conversationsData = [...this.props.data.hits];
        conversationsData[value.postIndex] = value.data;
        this.props.updatePostAfterTagToClientWidget({ conversationsData: { ...this.props.data, hits: conversationsData }, widgetId: this.props.widget.id });
    };

    downloadParentPostCsv = (data) => {
        this.props.downloadComments(data);
    };

    handleContextMenuClick = () => {
        if (this.props.isPublic) return;
        let newFilter = !this.props.drilldown_charts
            ? this.props.filters
                ? JSON.parse(JSON.stringify(this.props.filters))
                : {}
            : this.props.drilldown_filters.filter;
        this.props.handleContextMenuClick(newFilter);
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.hits.length === 0) || this.props.noTopicsSelected;
        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName name={this.props.widget.name} info="This chart shows raw conversation for the selected filters" />
                    <div className="dashboard-widget-actions">
                        {!this.props.isPublic && !nodata && <span className="post_count">{numberWithCommas(this.props.data.total) + " Posts"}</span>}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            !this.props.drilldown_charts &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    data-html2canvas-ignore="true"
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {
                            <>
                                {this.props.isPublic && nodata
                                    ? null
                                    : !this.props.drilldown_charts && (
                                          <Popup
                                              className="skiptranslate"
                                              trigger={
                                                  this.props.expandWidget ? (
                                                      <div data-html2canvas-ignore="true">
                                                          <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />{" "}
                                                      </div>
                                                  ) : (
                                                      <div data-html2canvas-ignore="true">
                                                          <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                      </div>
                                                  )
                                              }
                                              inverted
                                              content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                              size="mini"
                                              position="bottom center"
                                              style={{ zIndex: "99999" }}
                                          />
                                      )}
                            </>
                        }
                        {!this.props.isPublic && (
                            <MoreOptions data-html2canvas-ignore="true" className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />
                        )}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        <div className="view-all-posts-button" onClick={this.handleContextMenuClick}>
                            <span>View All Posts</span>
                        </div>
                        {!this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            !this.props.drilldown_charts &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            !this.props.drilldown_charts &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart dashboard-chart-raw-data">
                        <RawConversationPosts
                            data={this.props.data.hits}
                            company={this.props.company}
                            appliedFilter={this.props.appliedFilter}
                            customQuery={this.props.appliedFilter?.custom_query}
                            LNOfflineModalShow={(data) => this.LNOfflineModalShow(true, data)}
                            updatePostAfterSentimentUpdate={this.updatePostAfterSentimentUpdate}
                            updatePostAfterMarkAsIrr={this.updatePostAfterMarkAsIrr}
                            updatePostAfterTagToClient={this.updatePostAfterTagToClient}
                            downloadParentPostCsv={this.downloadParentPostCsv}
                            isPublic={this.props.isPublic}
                        />
                        {this.state.downloading && <DimmerComponent />}
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        drilldown_filters: state.dashboardReducer.drilldown_filters,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        updatePostAfterSentimentUpdateWidget: (arg) => dispatch(updatePostAfterSentimentUpdateWidget(arg)),
        updatePostAfterMarkAsIrrWidget: (arg) => dispatch(updatePostAfterMarkAsIrrWidget(arg)),
        updatePostAfterTagToClientWidget: (arg) => dispatch(updatePostAfterTagToClientWidget(arg)),
        downloadComments: (val) => dispatch(downloadComments(val)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RawConversations);
